import { render } from "./RadioPill.vue?vue&type=template&id=580148d6"
import script from "./RadioPill.vue?vue&type=script&lang=js"
export * from "./RadioPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__